module.exports = __webpack_public_path__ + "static/media/anaAward-head.f8bfa06c.webp";